import { writable } from "svelte/store"

export type Camera = {
  type: "camera"
  facing: "front" | "back"
  stream?: MediaStream
  canSwitch?: boolean
}
export type Images = {
  type: "images"
  images: { image: HTMLImageElement; exif: Record<string, unknown> }[]
}

/** An image source used for the image processing and capture */
export const source = {
  ...writable<Camera | Images | null>(null),

  images(images: Images["images"]) {
    this.set({ type: "images", images })
  },

  camera(init: Omit<Camera, "type">) {
    this.set({ type: "camera", ...init })
  },

  reset() {
    this.update((source) => {
      if (isCamera(source)) return { ...source, stream: undefined }
      if (isImages(source)) return { ...source, images: [] }
      return source
    })
  },

  clear() {
    this.set(null)
  },
}

export const getCameraFacing = (sources: string[]) => {
  const frontCameraIdx = sources.findIndex((s) => s === "front_camera" || s === "camera")
  const backCameraIdx = sources.findIndex((s) => s === "back_camera")

  if (frontCameraIdx !== -1 && backCameraIdx !== -1)
    return frontCameraIdx < backCameraIdx ? "front" : "back"

  if (backCameraIdx !== -1) return "back"

  return "front" // default
}

export const isCamera = (source: unknown): source is Camera => (source as Camera)?.type === "camera"
export const isImages = (source: unknown): source is Images => (source as Images)?.type === "images"
export const isIdleCamera = (source: unknown): source is Camera & { stream: undefined } =>
  isCamera(source) && (!source.stream || !source.stream.active)
